import React from "react";
import { sortAnswers } from "../helpers";

interface IFactualQuestionProps {
  question: Question;
  questionsAndAnswers: ChosenAnswer[];
  handleChange: (answer: number, question: number) => void;
  isContinueClicked: boolean;
}

export default function FactualQuestionCompactView({
  question,
  questionsAndAnswers,
  handleChange,
  isContinueClicked
}: IFactualQuestionProps) {
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];
  const { answers } = question;
  const sortedAnswers = sortAnswers(answers);

  const inputs = sortedAnswers?.map(
    (answer: { id: number; label: string }, i: number) => {
      return (
        <div key={i}>
          <input
            onChange={() => handleChange(answer.id, question.id)}
            id={answer.id.toString()}
            key={i}
            type="radio"
            required
            name={question.id.toString()}
            value={answer.id}
            className="ch-radio ch-mt--2 ch-mr--2 sm:ch-mr--2 sm:ch-mt--0"
            checked={storedAnswer && storedAnswer[0] === answer?.id}
            data-testid={`factQ-test-id-${answer.id}`}
          />
          <label
            htmlFor={answer.id.toString()}
            className="ch-radio__label ch-radio__label--primary ch-pr--4 ch-mt--2 sm:ch-mr--3 sm:ch-mt--0"
          >
            {answer.label}
          </label>
        </div>
      );
    }
  );

  return (
    <>
      <div className="ch-form__group--error">
        <p className="sm:ch-width--5 ch-width--12">
          <label>{question.content}</label>
        </p>
        {!storedAnswer && isContinueClicked && (
          <span className="ch-form__control-validation">Please choose an option</span>
        )}
      </div>
      <div className="ch-form__group sm:ch-display--flex ch-pb--5 ch-width--12">
        {inputs}
      </div>
    </>
  );
}
